import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
// tokens 必须在 global 之前：global.css 里的 var() 引用的就是这里定义的令牌
import './styles/tokens.css';
import './styles/global.css';

// 默认关闭；只有显式打开开关时才动态载入，mock 代码不会进生产包
if (import.meta.env.VITE_USE_MOCK === 'true') {
  const { installMock } = await import('./api/mock');
  installMock();
}

const el = document.getElementById('root');
if (!el) throw new Error('#root 不存在，检查 index.html');

createRoot(el).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
